import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Copyright() {
  const { t } = useTranslation();
  return (
    <div className="row justify-between items-center y-gap-10">
      <div className="col-auto">
        <div className="row x-gap-30 y-gap-10">
          <div className="col-auto">
            <div className="d-flex items-center">©NIPPON TRAVEL AGENCY Co.,LTD. All rights reserved.</div>
          </div>
          {/* End .col */}

          {/* End .col */}
        </div>
        {/* End .row */}
      </div>
      {/* End .col */}

      <div className="col-auto"></div>
      {/* End .col */}
    </div>
  );
}
